import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-share-icon',
  templateUrl: './communication-share.component.html'
})
export class CommunicationShareComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
